import { render } from "./AgreementsTable.vue?vue&type=template&id=0da1be25"
import script from "./AgreementsTable.vue?vue&type=script&lang=js"
export * from "./AgreementsTable.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src618844026/src/meta-page-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__